<script>

import {getMyCustomer, getSummaryData, markAlreadySendEmail} from "@/api/order/other";
import {exportB2bBill, exportB2bBillFormatter, exportMergeExcel} from "@/api/double/bill_hq";
import {copyToClipboard} from "@/utils/copyClick";
import {Button} from "iview";

export default {
  name: 'B2bSummary',
  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    startExportMergeExcel() {
      if (this.selectionBuff.length === 0) {
        return this.$Message.warning('请先选择合适的账单ID')
      }
      this.$Spin.show();
      exportMergeExcel({params: this.selectionBuff}).then(res => {
        this.$Spin.hide()
        if (res.data.code) {
          // 发生错误
          this.$Message.error(res.data.msg)
        } else {
          window.open(res.data.payload)
        }
      })
    },
    updateSelectionBuff(selection) {
      this.selectionBuff = []
      if (selection.length > 0) {
        let clientId = '';
        // 循环selection中的客户ID是否相同
        for (const selectionElement of selection) {
          if (!clientId) {
            clientId = selectionElement.account
          }
          if (clientId !== selectionElement.account) {
            this.selectionBuff  = []
            // 需要报错
            return this.$Message.error('请确保选择的账单归属于同一个用户')
          } else {
            this.selectionBuff.push(selectionElement.billId)
          }
        }
      }
    },
    tableHeight(resetHeight = 0, asNumber = false) {
      const tableHeight = parseFloat(getComputedStyle(document.querySelector('body')).height.replace('px')) - 140 - resetHeight
      return asNumber ? tableHeight : asNumber + 'px'
    },
    handleSubmit() {
      this.getList()
    },
    updatePage(val) {
      this.formValue.page = val
      this.getList()
    },
    updatePageSize(val) {
      this.formValue.pageSize = val
      this.getList()
    },
    getList() {
      getSummaryData(this.formValue).then((res) => {
        this.tableData = res.data.payload.rows
        this.tableCount = res.data.payload.total
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        if (query.length > 3) {
          getMyCustomer(query).then(res => {
            this.customerArray = res.data.payload
          })
        }
      } else {
        this.customerArray = [];
      }
    }
  },
  data() {
    const _this = this;
    return {
      selectionBuff: [],
      formValue: {
        timeType: 't1.create_time',
        billStatus: 'waitCharge',
        timeValue: [],
        keywords: '',
        page: 1,
        pageSize: 15,
        customerId: 0
      },
      remoteLoading: false,
      customerArray: [],
      fields: [
        {
          type: 'index',
          width: 60,
          align: 'center',
          fixed: 'left',
        },
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '账单号码',
          key: 'billNumber',
          align: 'center',
          width: 180,
          render: (h, {row, column, index}) => {
            let btns = [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      exportB2bBillFormatter(row.billId).then(res => {
                        window.open(res.data.payload.src)
                      })
                    }
                  }
                },
                row['billNumber']
              )
            ];

            return h('div', {}, btns)
          }
        },
        {
          title: '客户名称',
          key: 'account',
          align: 'center',
          width: 140
        },
        {
          title: '生成账单时间',
          key: 'makeBillTime',
          align: 'center',
          width: 180
        },

        {
          title: '账单金额',
          key: 'totalAmount',
          align: 'center',
          width: 130
        },
        {
          title: '出库时间',
          key: 'outboundTime',
          align: 'center',
          width: 180
        },
        {
          title: '支付时间',
          key: 'paymentTime',
          align: 'center',
          width: 180
        },
        {
          title: '总票数',
          key: 'shipmentCount',
          align: 'center',
          width: 120
        },
        {
          title: '订单号码',
          key: 'shipments',
          align: 'center',
          width: 260,
          tooltip: true,
          ellipsis: true
        },
        {
          title: '备注信息',
          key: 'remarks',
          align: 'center',
          minWidth: 160
        },
        {
          title: '操作',
          key: 'id',
          align: 'right',
          width: 240,
          render: (h, {row}) => {
            if (row.sendTime === 0) {
              return h(Button, {
                props: {
                  size: 'small',
                  type: 'primary',
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '邮件发送标记',
                      content: `<p>是否确认已经发送账单 ${row.billNumber} 发送给了客户 ${row.account}? </p>`,
                      okText: '确认',
                      cancelText: '取消',
                      loading: true,
                      onOk: () => {
                        this.$Spin.show()
                        markAlreadySendEmail(row.billId).then(res => {
                          this.$Message.success(res.data.msg)
                          this.$Spin.hide()
                          this.getList()
                          this.$Modal.remove();
                        })
                      },
                    });
                  }
                }
              }, '发送账单')
            } else {
              return h('span', row.sendTime)
            }
          }
        }
      ],
      tableData: [],
      tableCount: 0
    }
  },
}
</script>

<template>
  <Card :style="{height: tableHeight()}">
    <Form ref="frm" :model="formValue" :label-width="80" inline>
      <FormItem label="时间类型">
        <Select v-model="formValue.timeType" style="width:140px">
          <Option value="create_time" key="create_time">创建时间</Option>
          <Option value="payment_time" key="payment_time">支付时间</Option>
        </Select>
      </FormItem>
      <FormItem label="时间范围">
        <DatePicker type="datetimerange" confirm placement="bottom-end" v-model="formValue.timeValue"
                    style="width: 300px" placeholder="请选择时间范围"></DatePicker>
      </FormItem>
      <FormItem label="账单状态">
        <Select v-model="formValue.billStatus" style="width:180px">
          <Option value="waitCharge" key="waitCharge">待核销</Option>
          <Option value="charged" key="charged">已核销</Option>
          <Option value="particularlyCharge" key="particularlyCharge">部分核销</Option>
        </Select>
      </FormItem>
      <FormItem label="客户信息">
        <Select v-model="formValue.customerId" style="width:200px" clearable filterable
                :remote-method="remoteMethod"
                :loading="remoteLoading">
          <Option v-for="(item, key) in customerArray" :value="item.id" :key="'CI_' + item.id">{{ item.account }}
            ({{ item.name }})
          </Option>
        </Select>
      </FormItem>
      <FormItem label="关键字">
        <Input type="text" v-model="formValue.keywords" placeholder="请输入关键字"/>
      </FormItem>
      <FormItem label="" :label-width="0">
        <Button type="primary" @click="handleSubmit">搜索数据</Button>
        <Button type="danger" @click="startExportMergeExcel" style="margin-left: 10px;">导出账单EXCEL</Button>
      </FormItem>
    </Form>

    <div>
      <Table ref="tables" border :columns="fields" :data="tableData" :height="tableHeight(150, true)"
             @on-selection-change="updateSelectionBuff"></Table>
    </div>
    <Page :total="tableCount" show-total :styles="{marginTop: '20px'}" show-sizer
          show-elevator @on-change="updatePage" @on-page-size-change="updatePageSize"
          @on-prev="updatePage" @on-next="updatePage"
          :page-size="formValue.pageSize" :page-size-opts="[15, 50, 100]"/>
  </Card>
</template>

<style scoped>
.ive-table-fixed {
  margin-bottom: 10px !important;
  height: auto !important;
}
</style>
